import { Typography, TypographyVariant } from "@mui/material";
import { FC } from "react";

import NoPricePlaceholderMUI from "web/Layout/Common/Price/noPricePlaceholderMUI";
import __ from "web/Layout/Translations";

import formatNumber from "web/utils/data/parser/number/formatNumber";

import type { Nullable } from "web/types/Utils";

interface IPriceProps {
  value?: Nullable<string | number>;
  currency?: string;
  negative?: boolean;
  from?: boolean;
  dataT1?: string;
  alternativePlaceholder?: string;
  size?: string;
}

const priceSizeVariant: Record<string, TypographyVariant> = {
  S: "subtitle2",
  M: "subtitle1",
  L: "h3",
};

const PriceMui: FC<IPriceProps> = ({
  value = null,
  currency = "",
  negative = false,
  from = false,
  dataT1 = "price",
  alternativePlaceholder = "",
  size = "S",
}) => {
  const priceFormatted = formatNumber(value as string);

  if (Number(value) === 0) {
    return (
      <NoPricePlaceholderMUI
        dataT1={dataT1}
        alternativePlaceholder={alternativePlaceholder}
      />
    );
  }

  return (
    <Typography
      variant="subtitle2"
      textAlign="right"
      data-t1={`${dataT1}_value`}
      data-t2={formatNumber(value as string)}
      data-testid="price"
    >
      {negative ? "- " : null}

      {from ? (
        <Typography
          component="span"
          variant="subtitle2"
          data-t1={`${dataT1}_price_from`}
          data-t2={value}
        >
          {__("od")}&nbsp;
        </Typography>
      ) : null}

      <Typography
        sx={{ whiteSpace: "nowrap" }}
        component="span"
        variant={priceSizeVariant[size]}
      >
        {priceFormatted}
      </Typography>

      {currency && (
        <Typography
          sx={{ ml: 0.5 }}
          component="span"
          variant="subtitle2"
          data-t1={`${dataT1}_price_currency`}
          data-t2={value}
        >
          {currency}
        </Typography>
      )}
    </Typography>
  );
};

export default PriceMui;
